import * as Yup from "yup";

import { Strings } from "@app/constants";

//------------Login Schema--------------------------------

export const loginSchema = Yup.object()
  .shape({
    email: Yup.string()
      .required(Strings.validation.fieldRequired(Strings.fields.email))
      .email(Strings.validation.invalidEmail),
    password: Yup.string().required(
      Strings.validation.fieldRequired(Strings.fields.password)
    ),
  })
  .required();


//------------Login with OTP Schema--------------------------------

export const loginWithOtpSchema = Yup.object()
  .shape({
    phoneNumber: Yup.string()
      .required(Strings.validation.fieldRequired(Strings.fields.phoneNumber)),
    email: Yup.string()
      .required(Strings.validation.fieldRequired(Strings.fields.email))
      .email(Strings.validation.invalidEmail),
  })
  .required();

// ---------------signUpSchema-------------

export const signUpSchema = Yup.object()
  .shape({
    firstName: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.firstName)
    ),
    lastName: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.lastName)
    ),
    email: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.email)
    ),
    password: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.password)
    ),
    confirmPassword: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.conformPassword)
    ),
  })
  .required();

//------------ForgotPasswordSchema--------------------------------

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .required(Strings.validation.fieldRequired(Strings.fields.email))
    .email(Strings.validation.invalidEmail),
});

//------------ResetPasswordSchema--------------------------------

export const resetPasswordSchema = Yup.object()
  .shape({
    password: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.newPassword)
    ),
    confirmPassword: Yup.string().required(
      Strings.validation.fieldRequired(Strings.auth.conformNewPassword)
    ),
  })
  .required();
